<template>
  <div class="apply-detail-page">
    <div class="page-header">
      <div class="page-header-left">
        <div class="page-header-title">{{ pageName ? pageName + '询单报名列表' : 'XXX询单报名列表' }}</div>
        <div v-if="projectId" class="page-header-sub">项目 #{{ projectId }} · 询单报名与已报名管理</div>
      </div>
      <div v-if="infoStatus.status !== undefined" class="page-header-status">
        <span class="status-label">询单状态</span>
        <span class="status-value">{{ statusText }}</span>
      </div>
    </div>
    <infoCard
      :infoStatus.sync="infoStatus"
      :isShow="false"
      @infoPlatform="infoPlatform"
      @packagePlatforms="handlePackagePlatforms"
      @infoName="infoName"></infoCard>
    <section
      v-if="infoStatus.status===1&&infoStatus.is_apply===1&&userPermissions.indexOf('inquiry_apply') !== -1"
      class="detail-section">
      <div class="section-head">
        <div class="section-title">
          <span class="section-dot"></span>
          <span style="cursor: pointer" @click="handleGetApplyInfo">报名</span>
        </div>
      </div>
      <div v-if="projectId">
        <applyTable
          v-if="infoStatus?.status!==undefined"
          ref="applyTable"
          :infoPlatforms="infoPlatforms"
          :packagePlatforms="packagePlatformCodes"
          :infoStatus="infoStatus"
          @refresh="handleRefresh"></applyTable>
      </div>
    </section>

    <section class="detail-section enroll-section">
      <div class="section-head">
        <div class="section-title">
          <span class="section-dot"></span>
          <span style="cursor: pointer" @click="handleGetAppliedInfo">已报名列表</span>
        </div>
      </div>
      <div v-if="projectId">
        <enrolledTable
          v-if="projectId!==''&&infoStatus?.status!==undefined"
          ref="enrolledTable"
          :projectId="projectId"
          :infoPlatforms="infoPlatforms"
          :infoStatus="infoStatus"
          @refresh="handleRefresh"></enrolledTable>
      </div>

    </section>

    <section v-if="projectId!==''&&userPermissions.indexOf('inquiry_apply_log') !== -1"
             class="detail-section log-section">
      <div class="section-head log-head" @click=" showLog">
        <div class="section-title">
          <span class="section-dot"></span>
          <span>报名日志</span>
        </div>
        <div class="log-head-right">
          <el-tag size="mini" class="log-state-tag" :class="{ collapsed: !logVisible }">
            {{ logVisible ? '收起' : '已收起' }}
          </el-tag>
          <i :class="logVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="log-arrow"></i>
        </div>
      </div>
      <log v-show="logVisible" ref="applyLog" :projectId="projectId"></log>
    </section>

  </div>

</template>

<script>
import PriceGrids from '@/pages/publication/compoents/PriceGrids'
import infoCard from './components/infoCard'
import {mapGetters} from 'vuex'
import applyTable from '@/pages/inquiries/apply/applyTable.vue'
import enrolledTable from '@/pages/inquiries/apply/enrolledTable.vue'
import log from '@/pages/inquiries/components/log.vue'

export default {
  name: 'applyDetail',
  components: {
    PriceGrids, infoCard, applyTable, enrolledTable, log
  },
  data() {
    return {
      infoData: {},
      multipleSelection: [],
      drawer: false,
      infoPlatforms: [],
      packagePlatformCodes: [],
      infoStatus: {},
      tabPlatforms: [],
      divideLog: [],
      projectId: '',
      pageName: '',
      logVisible: false,
    }
  },

  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    statusText() {
      const map = {1: '进行中', 2: '已完结', 3: '已作废'}
      return map[this.infoStatus.status] || '-'
    }
  },

  methods: {
    // 合作平台
    infoPlatform(val) {
      this.infoPlatforms = val
    },
    handlePackagePlatforms(val) {
      this.packagePlatformCodes = val || []
    },
    infoName(val) {
      this.pageName = val
    },
    async handleGetApplyInfo() {
      //可报名列表
      this.$refs.applyTable && this.$refs.applyTable.getInfo(this.projectId)
    },
    async handleGetAppliedInfo() {
      //已报名列表
      this.$refs.enrolledTable && this.$refs.enrolledTable.getInfo(this.projectId)
    },
    handleRefresh() {
      //可报名列表
      this.handleGetApplyInfo()
      //已报名列表
      this.handleGetAppliedInfo()

    },
    showLog() {
      this.logVisible = !this.logVisible;
      if (this.logVisible)
        this.$refs.applyLog && this.$refs.applyLog.getlogsInquiry()
    }
  },
  mounted() {
    this.projectId = this.$route.params.id
    // this.handleRefresh()
  }
}
</script>

<style lang="scss" scoped>
.apply-detail-page {
  padding: 16px 18px 18px;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.page-header {
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.page-header-title {
  color: #0f172a;
  font-size: 24px;
  font-weight: 800;
}

.page-header-sub {
  margin-top: 6px;
  color: #8793a8;
  font-size: 13px;
}

.page-header-status {
  padding: 8px 16px;
  border: 1px solid #eef1f6;
  border-radius: 8px;
  background: #f8fafc;
  text-align: center;
  flex: 0 0 auto;
}

.status-label {
  display: block;
  color: #9aa3b2;
  font-size: 12px;
}

.status-value {
  display: block;
  margin-top: 3px;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.enroll-section {
  margin-top: 12px;
}

.log-head {
  cursor: pointer;
}

.log-arrow {
  color: #8d9aaf;
  font-size: 16px;
}

.log-head-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.log-state-tag {
  background: var(--primary);
  border: none;
  color: #fff;
  font-weight: 600;
}

.log-state-tag.collapsed {
  background: #eef1f6;
  color: #8a96ab;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
}

.section-title {
  display: flex;
  align-items: center;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
}

.section-dot {
  width: 9px;
  height: 9px;
  margin-right: 10px;
  border-radius: 50%;
  background: var(--primary);
  box-shadow: 0 0 0 4px rgba(255, 49, 118, 0.13);
}

::v-deep .info-overview {
  padding-left: 0;
  padding-right: 0;
}

</style>
